<ng-container *ngIf="pageReady$ | async">
        <div *ngIf="(ui.bannerText || (tracking.trialCode && !!daysInTrial)) && ui.isMobile">
        <app-countdown-banner [displaySalesBanner]="!!ui?.bannerText" banner_txt="{{ui.bannerText}}" [smallScreen]="true" [trialCode]="!!tracking.trialCode" [trialDays]="daysInTrial"></app-countdown-banner>
    </div>
    <div class="membership-container text-center p-4 mt-6 mb-0 mx-auto overflow-hidden" style="max-width:1200px;">
        <div>
            <h1 class="text-5xl md:text-6xl">Get the best deals with Premium+.</h1>
            <p class="mb-6 text-xl">Save an average of $1,300 per flight.</p>
        </div>

        <div class="pick-container justify-content-center m-auto">
            <div *ngIf="(ui.bannerText || (tracking.trialCode && !!daysInTrial) ) && !ui.isMobile" class="flex p-grid justify-content-center p-mb-4">
                <div [ngStyle]="getBannerStyle()" class="exclusive-offer">
                    <app-countdown-banner
                        [displaySalesBanner]="!!ui?.bannerText"
                        [banner_txt]="ui.bannerText"
                        [smallScreen]="filteredMembershipsArray.length === 1"
                        [trialCode]="!!tracking.trialCode"
                        [trialDays]="daysInTrial"
                        class="p-fluid">
                    </app-countdown-banner>
                </div>
            </div>

            <div *ngIf="!ui.displayPlanCarousel else mobileView" class="flex justify-content-evenly flex-wrap" [ngClass]="{'justify-content-center': filteredMembershipsArray.length === 1,  'justify-content-between m-auto': filteredMembershipsArray.length === 2, 'justify-content-evenly': filteredMembershipsArray.length >= 3}" [ngStyle]="filteredMembershipsArray.length === 2 ? {'max-width.px': 860} : null">
                <div *ngFor="let plan of filteredMembershipsArray; trackBy: trackByPlanName" class="col-12 md:col-5 plan-card flex flex-column justify-content-between bg-white border-round-lg p-4 border-none text-left w-full position-relative"
                     [ngClass]="{ 'basic': plan.name === ProductNames.Basic, 'premium': plan.name === ProductNames.PremiumPlus || plan.name === ProductNames.Premium, 'is-current-plan': plan.isCurrentPlan }">
                    <div class="title-row flex align-items-center justify-content-between w-full">
                        <h2 class="text-lg m-0">{{ plan.name }}</h2>
                        <div *ngIf="plan.isPopular" class="popular-tag flex align-items-center justify-content-center"><i class="ph-fill ph-fire"></i> Popular</div>
                    </div>
                    <div class="price-container flex flex-column align-items-start pb-3 border-dashed border-top-none border-x-none border-bottom-1 border-gray-300">
                        <ng-container *ngIf="plan.planDef | planPricingDuration: labelsCtx as labels">
                            <h3 class="price">{{ labels.price }}</h3>
                            <span class="duration text-base font-medium m-1">{{ labels.duration }}</span>
                        </ng-container>
                    </div>
                    <ul class="features p-0 list-none my-1 font-semibold">
                        <li *ngFor="let feature of plan.features" class="py-2 flex align-items-center">
                            <i [ngClass]="feature.icon" class="border-none border-circle p-1 inline-flex align-items-center justify-content-center"></i>
                            {{ feature.text }}
                        </li>
                    </ul>
                    <button type="button" pButton class="full-width font-semibold w-full mt-1 flex justify-content-center" [ngClass]="plan.buttonClass" (click)="plan.buttonAction()" [disabled]="plan.isCurrentPlan" [loading]="plan.tier === Tiers.Free && ui.isLoading"   [label]="plan.name | planCardButtonText: labelsCtx : plan.isCurrentPlan">
                    </button>
                </div>
            </div>
            <p class="cancel-note mt-4 text-base">* Cancel anytime, no questions asked.</p>
        </div>
    </div>
    <ng-container *ngIf="!partner.isPartnerView">
        <div class="how-it-works-container" >

            <h2 class="text-5xl md:text-6xl text-left md:text-center mb-3" style="padding: 0 20px">Flights are just the start</h2>
            <p class="text-xl mb-0 md:mb-7 text-left md:text-center" style="padding: 0 20px">
                Our members unlock thousands in travel savings every single year with a growing list of perks and features.
            </p>

            <features *ngIf="ui.isMobile"></features>
            <div class="features-container" *ngIf="!ui.isMobile">
                <div *ngFor="let step of steps" class="feature-card text-center flex flex-column">
                    <h3>{{ step.title }}</h3>
                    <p>{{ step.text }}</p>
                    <img class="w-full" [src]="step.image" alt="{{ step.title }}">
                </div>
            </div>
        </div>
        <!--FAQs-->
        <div class="faqs-container">
            <h2 class="text-5xl md:text-6xl text-center mb-3">FAQs</h2>
            <p class="text-xl mb-3 md:mb-7">
                Can’t find the answer to your question? Shoot us a message
                <a href="mailto:support@dollarflightclub.com" style="color:#007aff;"> here</a>.
            </p>

            <div *ngFor="let item of faqs" class="custom-accordion-item border-top-1 border-200 overflow-hidden mb-2">
                <div class="custom-accordion-header flex align-items-center justify-content-between font-medium" (click)="toggleAccordion(item)">
                    <span class="text-left">{{ item.question }}</span>
                    <i class="faq-icon pi" [ngClass]="item.open ? 'pi-minus' : 'pi-plus'"></i>
                </div>
                <div class="custom-accordion-content" *ngIf="item.open">
                    <p>{{ item.answer }}</p>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #mobileView>
        <div class="mobile-container membership-carousel-mobile" appSwipeScroll *ngIf="ui.displayPlanCarousel">
            <p-carousel
                [value]="filteredMembershipsArray"
                [numScroll]="1"
                [responsiveOptions]="responsiveOptions"
                [circular]="false"
                [showIndicators]="false"
                [showNavigators]="false"
                class="draggable plan-selection-carousel"
            >
                <ng-template pTemplate="item" let-plan>
                    <div class="plan-card flex flex-column justify-content-between bg-white border-round-lg p-4 border-none text-left w-full position-relative m-2"
                         [ngClass]="{
        'basic': plan.name === ProductNames.Basic,
        'premium': plan.name === ProductNames.PremiumPlus || plan.name === ProductNames.Premium, 'is-current-plan': plan.isCurrentPlan
      } "
                    >
                        <div class="title-row flex align-items-center justify-content-between w-full">
                            <h2 class="text-lg m-0">{{ plan.name }}</h2>
                            <div *ngIf="plan.isPopular" class="popular-tag flex align-items-center justify-content-center">
                                <i class="ph-fill ph-fire"></i> Popular
                            </div>
                        </div>
                        <div class="price-container flex flex-column align-items-start pb-4 border-dashed border-top-none border-x-none border-bottom-1 border-gray-300">
                            <ng-container *ngIf="plan.planDef | planPricingDuration: labelsCtx as labels">
                                <h3 class="price">{{ labels.price }}</h3>
                                <span class="duration text-base font-medium m-1">{{ labels.duration }}</span>
                            </ng-container>
                        </div>
                        <ul class="features p-0 list-none my-1 font-semibold">
                            <li class="py-2 flex align-items-center" *ngFor="let feature of plan.features">
                                <i [ngClass]="feature.icon" class="border-none border-circle p-1 inline-flex align-items-center justify-content-center"></i>
                                {{ feature.text }}
                            </li>
                        </ul>
                        <button
                            type="button"
                            pButton
                            class="full-width font-semibold w-full mt-1 flex justify-content-center"
                            [ngClass]="plan.buttonClass"
                            (click)="plan.buttonAction()"
                            [disabled]="plan.isCurrentPlan"
                        >
                            {{ plan.name | planCardButtonText: labelsCtx : plan.isCurrentPlan }}

                        </button>
                    </div>
                </ng-template>
            </p-carousel>
        </div>
    </ng-template>

    <!--EMAIL MODAL-->
    <app-generic-modal
        [(visible)]="ui.displayEmailModal"
        [showHeader]="true"
        width="400px"
        [dismissableMask]="false"
        styleClass="email-modal"
    >
        <form (ngSubmit)="submitEmail()" #emailForm="ngForm" class="p-fluid">
            <h4 class="w-full text-center">Enter your email</h4>
            <input name="email" [(ngModel)]="email" #emailCtrl="ngModel" class="w-full mb-3 p-inputtext" placeholder="janedoe@example.com" style="font-size: 16px;">
            <button type="submit" pButton severity="info" [outlined]="true" class="w-full justify-content-center" [disabled]="emailForm.invalid">Enter</button>

        </form>
    </app-generic-modal>
</ng-container>
